<template>
  <nav class="navbar">
    <div class="container">
      <div class="nav-content">
        <div class="logo">
          <router-link to="/">
            <img src="@/assets/img/logo2.png" alt="古杉数据" />
          </router-link>
        </div>
        <ul class="nav-menu">
          <li><router-link to="/">首页</router-link></li>
          
          <!-- 咨询下拉菜单 -->
          <li class="nav-dropdown">
            <router-link to="/consulting">咨询</router-link>
            <div class="dropdown-menu">
              <router-link to="/consulting/digital-transformation">数字化转型咨询</router-link>
              <router-link to="/consulting/data-governance">数据治理咨询</router-link>
              <router-link to="/consulting/audit-risk-consulting">审计风控合规咨询</router-link>
              <router-link to="/consulting/ai-consulting"> AI及大模型咨询</router-link>
            </div>
          </li>
          
          <!-- 产品下拉菜单 -->
          <li class="nav-dropdown">
            <router-link to="/product">产品</router-link>
            <div class="dropdown-menu">
              <router-link to="/product/smart-audit-risk">智慧审计与全面风险管理平台</router-link>
              <router-link to="/product/risk-compliance-platform">风控合规数字化平台</router-link>
              <router-link to="/product/data-governance-platform">智能数据管理与治理平台</router-link>
              <router-link to="/product/ai-agent">AI智能体（分析&治理）</router-link>
              <router-link to="/product/penetrating-supervision">穿透式监管</router-link>
            </div>
          </li>
          
          <!-- 培训下拉菜单 -->
          <li class="nav-dropdown">
            <router-link to="/training">培训</router-link>
            <div class="dropdown-menu">
              <router-link to="/training/corporate-training">2026年全年培训计划</router-link>
              <router-link to="/training/data-analysis">财务数据分析</router-link>
              <router-link to="/training/ai-practical">AI大语言模型实战</router-link>
              <router-link to="/training/cdo">CDO 课程</router-link>
              <router-link to="/training/data-management">数据管理分析与治理</router-link>
            </div>
          </li>
          
          <!-- 行业下拉菜单 -->
          <li class="nav-dropdown">
            <router-link to="/industry">行业</router-link>
            <div class="dropdown-menu">
              <router-link to="/industry/energy">能源</router-link>
              <router-link to="/industry/manufacturing">制造</router-link>
              <router-link to="/industry/stateowned">央企国企</router-link>
              <router-link to="/industry/bank">银行</router-link>
              <router-link to="/industry/insurance">保险</router-link>
            </div>
          </li>
          
          <!-- 研究中心下拉菜单 -->
          <li class="nav-dropdown">
            <router-link to="/research">研究中心</router-link>
            <div class="dropdown-menu">
              <a href="/research#digital">数字化研究</a>
              <a href="/research#governance">数据治理知识库</a>
              <a href="/research#trends">审计风控趋势</a>
              <a href="/research#policy">政策解读</a>
              <a href="/research#whitepaper">白皮书下载</a>
            </div>
          </li>
          
          <li><router-link to="/case">客户案例</router-link></li>
          <li><router-link to="/about">关于我们</router-link></li>

          <div class="actions">
            <router-link to="/appointment" class="btn-consult">预约咨询</router-link>
            <button class="btn-menu">
              <svg class="icon" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 6h16M4 12h16M4 18h16" />
              </svg>
            </button>
          </div>

        </ul>
      </div>
    </div>
  </nav>
</template>

<script>
export default {
  name: 'NavBar'
}
</script>

<style scoped>
.navbar {
  background-color: var(--white);
  border-bottom: 1px solid var(--divider);
  position: sticky;
  top: 0;
  z-index: 100;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
}

.nav-content {
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 64px;
}

.logo a {
  display: flex;
  align-items: center;
  height: 40px;
}

.logo img {
  height: 40px;
  width: auto;
  object-fit: contain;
}

.nav-menu {
  display: flex;
  list-style: none;
  gap: 32px;
  align-items: center;
}

.nav-menu > li {
  position: relative;
}

.nav-menu a {
  color: var(--text-primary);
  font-size: 14px;
  position: relative;
  padding: 4px 0;
  display: block;
}

.nav-menu > li > a:hover,
.nav-menu > li > a.router-link-active {
  color: var(--brand-blue);
}

.nav-menu > li > a.router-link-active::after {
  content: '';
  position: absolute;
  bottom: -20px;
  left: 0;
  right: 0;
  height: 2px;
  background-color: var(--brand-blue);
}

/* 下拉菜单样式 */
.nav-dropdown {
  position: relative;
}

.dropdown-menu {
  position: absolute;
  top: 100%;
  left: 50%;
  transform: translateX(-50%);
  margin-top: 20px;
  background-color: var(--white);
  border: 1px solid var(--divider);
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  min-width: 180px;
  padding: 8px 0;
  opacity: 0;
  visibility: hidden;
  transition: opacity 0.2s ease, visibility 0.2s ease;
  z-index: 1000;
}

.nav-dropdown:hover .dropdown-menu {
  opacity: 1;
  visibility: visible;
}

.dropdown-menu a {
  padding: 10px 20px;
  color: var(--text-primary);
  font-size: 14px;
  white-space: nowrap;
  transition: background-color 0.2s ease, color 0.2s ease;
}

.dropdown-menu a:hover {
  background-color: var(--porcelain-blue);
  color: var(--brand-blue);
}

.dropdown-menu a.router-link-active {
  color: var(--brand-blue);
  background-color: var(--porcelain-blue);
}

.dropdown-menu a.router-link-active::after {
  display: none;
}


/* 容器：flex布局，垂直居中，子元素间距0.75rem */
.actions {
  display: flex;
  align-items: center;
  gap: 0.95rem;
  
}

/* 咨询按钮基础样式 */
.nav-menu .btn-consult {
  display: inline-block;                /* 可见并作为行内块元素 */
  padding: 5px 10px;                   /* 上下5px，左右10px，使按钮更紧凑 */
  min-width: 60px;                      /* 最小宽度，保证按钮“长一点” */
  text-align: center;
  font-size: 12px;                   /* 稍大文字 */
  background-color: #1e3a8a;           /* 品牌色（可替换） */
  color: #fff;                          /* 文字为白色 */
  font-weight: 600;
  border-radius: 0.375rem;              /* 6px（rounded-md） */
  box-shadow: 0 1px 3px rgba(0,0,0,0.1); /* shadow-sm */
  transition: background-color 0.15s ease, transform 0.15s ease;
  text-decoration: none;                /* 去除下划线 */
}


.nav-menu .btn-consult:visited,
.nav-menu .btn-consult:hover,
.nav-menu .btn-consult:active {
  color: #fff;
}


/* 响应式设计 */
@media (max-width: 1024px) {
  .nav-menu {
    gap: 20px;
  }
  
  .nav-menu a {
    font-size: 13px;
  }
}

@media (max-width: 768px) {
  .nav-menu {
    display: none;
  }
  
  /* 移动端菜单样式可以在这里添加 */
}
</style>
